import React, {useState} from 'react'
import { Box, Typography, Modal } from '@mui/material';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import styled from "styled-components";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BooksRoomTypeCommonModal from '../BlocksRoomTypeCommonModal';


const EditDeleteButton = () => {
    return (
        <>
      <EditIcon/> <DeleteIcon/>
      </>
    );
  };

const columns = [
    { field: 'id', headerName: 'Sl No', flex: 1, headerAlign: "center", align: "center" },
    { field: 'blockName', headerName: 'Block Name', flex: 1, headerAlign: "center", align: "center" },
    { field: 'floorManagement', headerName: 'Floor Management', flex: 1 , headerAlign: "center", align: "center"},
    { field: 'action', headerName: 'Action', flex: 1, headerAlign: "center", align: "center" , renderCell: (params) => (
        <EditDeleteButton/>
      )  }
  ];
  
  
  const rows = [
    { id: 1, blockName: "OTP registration", floorManagement: 'Lorem ipsum' },
    { id: 2, blockName: "Fees Paid", floorManagement: 'Lannister'},
    { id: 3, blockName: "OTP Testing"  , floorManagement: 'Lannister'},
    { id: 4, blockName: "OTP Testing"  , floorManagement: 'Lannister'},
  
  ];


function Blocks() {

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ width: '100%' }} >

        <Box sx={{display: "flex", justifyContent: "flex-end", mb: "30px"}} >
            <Button variant="contained" sx={{color: 'white'}} onClick={handleOpen} color="success" >Blocks</Button>
        </Box>

        <div style={{ height: 400, width: '100%', marginTop: '40px' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          pageSizeOptions={[5, 10]}
        />
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-floorManagement"
        >
        <BooksRoomTypeCommonModal title="Add New Block"  handleClose={handleClose} />
      </Modal>

    </Box>
  )
}

export default Blocks